import { render, staticRenderFns } from "./FormTransferBetweenUsers.vue?vue&type=template&id=9b5251a2&scoped=true"
import script from "./FormTransferBetweenUsers.vue?vue&type=script&lang=js"
export * from "./FormTransferBetweenUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5251a2",
  null
  
)

export default component.exports